/**
 * Loads quick-add and product-form scripts on first interaction only.
 */
(function () {
  const urls = window.sbQuickAddUrls || [];
  if (!urls.length) return;

  let loaded = false;
  let loading = null;

  const loadScripts = () => {
    if (loaded) return Promise.resolve();
    if (loading) return loading;

    loading = Promise.all(
      urls.map(
        (src) =>
          new Promise((resolve, reject) => {
            if (document.querySelector(`script[src="${src}"]`)) {
              resolve();
              return;
            }
            const script = document.createElement('script');
            script.src = src;
            script.defer = true;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Failed to load ${src}`));
            document.head.appendChild(script);
          })
      )
    )
      .then(() => customElements.whenDefined('quick-add-modal'))
      .then(() => {
        loaded = true;
        cleanup();
      })
      .catch(() => {
        loading = null;
      });

    return loading;
  };

  const cleanup = () => {
    document.removeEventListener('pointerenter', onPointer, true);
    document.removeEventListener('click', onClick, true);
  };

  const isQuickAddTarget = (target) =>
    Boolean(target.closest('.quick-add, .quick-add__submit, quick-add-modal'));

  const onPointer = (event) => {
    if (isQuickAddTarget(event.target)) loadScripts();
  };

  const onClick = (event) => {
    if (!isQuickAddTarget(event.target) || loaded) return;
    event.preventDefault();
    event.stopPropagation();
    const el = event.target;
    loadScripts().then(() => el.click());
  };

  document.addEventListener('pointerenter', onPointer, true);
  document.addEventListener('click', onClick, true);
})();
